// extracted by mini-css-extract-plugin
module.exports = {"drag_and_drop":"DragAndDrop_drag_and_drop__250xn","fade-in":"DragAndDrop_fade-in__2IG7u"};